import React from 'react'
import Slider from 'react-slick'
import { Activity } from './index'

const SLIDER_SETTINGS = {
  dots: false,
  infinite: false,
  arrows: false,
  variableWidth: true,
  speed: 500,
  swipe: true,
  slidesToScroll: 1
}

const SliderActivities = ({ collection, type, title, country, dateRange }) => {
  let sliderRef

  return (collection && collection.length) > 0 ? (
    <div className="carousel-container">
      <div className="heading clearfix">
        <h3 className="pull-left">{title}</h3>
        <button className="btn btn-link pull-right">See all</button>
      </div>
      <div className="slider-wrapper">
        <Slider {...SLIDER_SETTINGS} ref={slider => (sliderRef = slider)}>
          {collection.map((item, index) => <Activity key={index} type={type} data={item} country={country} dateRange={dateRange}/>)}
        </Slider>

        <nav className={'slider-nav'}>
          <button
            className="btn-slider-nav prev"
            onClick={() => {
              sliderRef.slickPrev()
            }}
          >
            <img src={'/img/arrow-right.svg'} alt="" />
          </button>

          <button
            className="btn-slider-nav next"
            onClick={() => {
              sliderRef.slickNext()
            }}
          >
            <img src={'/img/arrow-right.svg'} alt="" />
          </button>
        </nav>
      </div>
    </div>
  ) : null
}

export default SliderActivities



// WEBPACK FOOTER //
// src/components/homepage/SliderActivities.js